
import Form from '@/ui-kit/components/form';
import FormField from '@/ui-kit/components/form/form-field';
import Gutter from '@/ui-kit/components/gutter';
import { FormFieldProperty } from '@/ui-kit/components/form/enums';
import { ControlType } from '@/ui-kit/components/form/controls/enums';
import { TextInputProperty, TextInputType } from '@/ui-kit/components/form/controls/components/text-input/enums';
import { InputFillType, InputSlotType } from '@/ui-kit/components/form/controls/shared/input/enums';
import { StylePositionType, StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { AuthLoginFormControlName } from './enums';
import { authLoginFormGroup } from './controls';

export default {
  name: 'AuthLoginForm',
  components: {
    Gutter,
    Form,
    FormField,
  },
  data() {
    return {
      StylePositionType,
      StyleSizeType,
      StyleColorSchemeType,
      FormFieldProperty,
      ControlType,
      InputSlotType,
      AuthLoginFormControlName,
      formGroup: authLoginFormGroup,
    };
  },
  computed: {
    emailInputProps() {
      return {
        [TextInputProperty.Name]: AuthLoginFormControlName.Email,
        [TextInputProperty.FillType]: InputFillType.Outlined,
        [TextInputProperty.TextType]: TextInputType.Text,
        [TextInputProperty.Label]: 'Email Address',
      };
    },
    passwordInputProps() {
      return {
        [TextInputProperty.Name]: AuthLoginFormControlName.Password,
        [TextInputProperty.FillType]: InputFillType.Outlined,
        [TextInputProperty.Label]: 'Password',
      };
    },
  },
};
